// Global Instructions Rule Applied!
import React, { createContext, useContext, useState } from 'react'

// Create the context
export const RightMenuContext = createContext()

/**
 * Custom hook to access right menu functionality
 * Provides methods to control the right menu width dynamically
 */
export function useRightMenu() {
  const context = useContext(RightMenuContext)
  if (!context) {
    throw new Error('useRightMenu must be used within a RightMenuProvider')
  }
  return context
}

/**
 * RightMenuProvider component that manages right menu width state
 * Allows components to dynamically adjust the right menu width
 */
export function RightMenuProvider({ children }) {
  const [width, setWidth] = useState('35%') // Default width

  const setRightMenuWidth = (newWidth) => {
    setWidth(newWidth)
  }

  const resetRightMenuWidth = () => {
    setWidth('35%')
  }

  const contextValue = {
    width,
    setRightMenuWidth,
    resetRightMenuWidth
  }

  return <RightMenuContext.Provider value={contextValue}>{children}</RightMenuContext.Provider>
}
